<template>
  <div>
    <div class="artcol_top_bar">
      <span class="artcol_tip">文章上传</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="line_con">
      <span class="txt_label">选择文章：</span>
      <div class="add_in_con1">
        <el-upload
          class="upload-demo"
          accept=".jpg,.png,.pdf,.doc,.docx"
          drag
          :action="upload_url"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          multiple
          :limit="1"
          :headers="dynamicHeaders"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">
            请上传jpg、png、doc、docx或可解析的pdf文件
          </div>
          <div class="el-upload__tip" slot="tip"></div>
        </el-upload>
      </div>
    </div>
    <div class="line_con">
      <span class="txt_label">选择分类：</span>
      <div class="add_in_con1 type_ses_con">
        <img src="../assets/add.png" class="add_img" @click="addClass" />
        <div class="type_ses_left_con">
          <select
            class="el-dropdown-link_left"
            v-model="firstLevelClassId"
            @change="changeFirstLevelClass"
          >
            <option
              v-for="item in firstLevelClass"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>
          <select class="el-dropdown-link_right" v-model="secondLevelClassId">
            <option
              v-for="item in secondLevelClass"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">添加标签：</span>
      <div class="add_in_con">
        <i class="el-icon-collection-tag"></i>
        <input class="add_in" placeholder="请输入标签" v-model="inputTag" />
      </div>

      <button class="start_col_btn" @click="addTag">添加</button>
    </div>

    <div class="line_con">
      <span class="txt_label">&emsp;&emsp;&emsp;&emsp;&emsp;</span>
      <div class="label_con_up">
        <div
          class="out_label_up"
          v-for="(tag, idx) in tags"
          :key="tag.labelName"
          :class="{ selected_up: tag.isselected_up }"
          @click="toggleTag(tag)"
        >
          <div class="label_con_uptent_up">
            <div class="inlabel_up">{{ tag.labelName }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="btns_con">
      <!-- <button class="preview_btn" @click="preview">预 览</button> -->
      <button class="save_btn" @click="save">保 存</button>
    </div>
  </div>
</template>

<script>
import {
  articleCollect,
  saveArticle,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
  UplpadArticle,
  SaveUploadArticle,
  getAllTag,
  apiAddTag,
} from "@/api/article";
import { url } from "@/api/request";
import * as router from "@/api/router";
import * as dayjs from "dayjs";
export default {
  name: "artup",
  data() {
    return {
      firstLevelClass: [],
      firstLevelClassId: "",
      allSecondLevelClass: [],
      secondLevelClass: [],
      secondLevelClassId: "",

      userId: 1,
      articleTitle: "",
      tags: [],
      inputTag: "",
      upload_url: `${url}/api/kp/article/startUpload`,
      dynamicHeaders: null,
      fileList: [],
      createTime: null,
      collectionTime: null,
      fileUrl: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    uploadData() {
      return {
        userId: this.userId,
      };
    },
    articleInfo() {
      return this.$store.getters.getLocalArticleInfo;
    },
    collectionProcessStatus() {
      return this.collectionProcess == 100 ? "success" : "warning";
    },
  },

  mounted() {
    console.log(url); //http://localhost:8080
    this.dynamicHeaders = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    console.log("onShow");
    if (this.articleInfo.ing) {
      this.refreshClassification();
      // 将this.articleInfo赋值到页面data
      for (let key in this.articleInfo) {
        console.log(key);
        console.log(this.articleInfo[key]);
        this[key] = this.articleInfo[key];
      }
      return;
    } else {
      this.clearFormData();
    }
    this.loadData(); // 调用方法获取标签
    this.userId = this.userInfo.id;

    this.refreshClassification();
  },
  watch: {},
  methods: {
    /**
     * 刷新分类
     */
    refreshClassification() {
      let that = this;
      Promise.all([
        GetFirstLevelClassification({
          userId: this.userInfo.id || 1,
        }),
        GetSecondLevelClassification({
          userId: this.userInfo.id || 1,
        }),
      ])
        .then((responses) => {
          // responses[0] 是 GetFirstLevelClassification 的结果
          // responses[1] 是 GetSecondLevelClassification 的结果

          // 处理 GetFirstLevelClassification 的结果
          that.firstLevelClass.splice(0, that.firstLevelClass.length);
          that.firstLevelClassId = "";
          console.log("GetFirstLevelClassification Response:", responses[0]);
          responses[0].data.forEach((item) => {
            that.firstLevelClass.push(item);
          });

          // 处理 GetSecondLevelClassification 的结果
          that.allSecondLevelClass.splice(0, that.secondLevelClass.length);
          that.secondLevelClassId = "";
          console.log("GetSecondLevelClassification Response:", responses[1]);

          responses[1].data.forEach((item) => {
            that.allSecondLevelClass.push(item);
          });

          if (that.articleInfo.articleTitle) {
            console.log(that.articleInfo.articleTitle);
            // 根据一级分类处理二级分类
            const arr = that.allSecondLevelClass.filter((item) => {
              return item.parentId == that.articleInfo.firstLevelClassId;
            });
            arr.forEach((item) => {
              that.secondLevelClass.push(item);
            });

            // 将this.articleInfo赋值到页面data
            for (let key in that.articleInfo) {
              that[key] = that.articleInfo[key];
            }
          }
        })
        .catch((error) => {
          // 处理任一 promise 出错的情况
          console.error("Error in one of the promises:", error);
        });
    },

    async loadData() {
      try {
        await this.fetchTags();
        // 在这里调用其他需要异步加载的数据...
      } catch (error) {
        console.error("加载数据错误:", error);
      }
    },
    async fetchTags() {
      getAllTag({
        userId: this.userId,
      })
        .then((response) => {
          //console.log("ddd", response);
          const items = response.data;
          this.tags = [];
          // 创建包含 labelName 和 isselected_up 属性的对象数组
          console.log(items);
          this.tags = items.map((label) => ({
            ...label,
            isselected_up: false,
          }));
        })
        .catch((error) => {
          console.error("获取标签失败:", error);
        });
    },
    toggleTag(tagObj) {
      tagObj.isselected_up = !tagObj.isselected_up;
    },
    addTag() {
      if (!this.inputTag) {
        // 标签为空或已存在于 tags 中时不添加
        return;
      }
      const newTag = {
        labelId: NaN,
        labelName: this.inputTag,
        isselected_up: true,
      };

      apiAddTag(newTag)
        .then((res) => {
          newTag.labelId = res.data.labelId;
          this.tags.push(newTag); // 添加新的标签对象到 tags 数组
          this.inputTag = ""; // 清空输入框
        })
        .catch((e) => {
          console.error(e);
        });
    },

    deleteTag(idx) {
      if (idx < 0 || idx >= this.tags.length) {
        return;
      }
      // 删除this.tags中的下标为idx元素
      this.tags.splice(idx, 1);
    },
    beforeUpload(file) {
      var fileName = file.name;

      this.createTime = dayjs(file.lastModified).format("YYYY-MM-DD HH:mm:ss");
      console.log(this.createTime);
      var fileType = fileName.substring(fileName.lastIndexOf("."));
      if (
        fileType !== ".jpg" &&
        fileType !== ".png" &&
        fileType !== ".pdf" &&
        fileType !== ".doc" &&
        fileType !== ".docx"
      ) {
        this.$message.error({
          message: `请上传jpg/png/pdf/doc/docx文件！`,
        });
        return false;
      }

      this.loading = this.$loading({
        lock: true,
        text: "正在上传文章...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        target: ".main_right",
      });
    },
    handleSuccess(response, file, fileList) {
      this.$store.dispatch("recordData2", {
        ...this.articleInfo,
        fileList,
      });
      this.fileList = fileList;
      this.articleTitle = file.name;
      console.log(response);
      this.fileUrl = response.url;
      this.loading.close();
    },

    handleRemove(file, fileList) {
      this.$store.dispatch("recordData2", {
        ...this.articleInfo,
        fileList,
      });
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    changeFirstLevelClass() {
      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      console.log(this.firstLevelClassId);
      const arr = this.allSecondLevelClass.filter(
        (item) => item.parentId == this.firstLevelClassId
      );
      arr.forEach((item) => {
        this.secondLevelClass.push(item);
      });
    },
    /**
     * 添加分类
     */
    addClass() {
      this.$store.dispatch("recordData2", this.getFormData());
      // 跳转到分类管理页面，并通过params传值
      this.$router.push({
        name: "clsmag",
        params: {
          back: true,
        },
      });
    },

    /**
     * 组装表单的数据
     */
    getFormData() {
      return {
        fileList: this.fileList,
        articleTitle: this.articleTitle,
        tags: this.tags,
        firstLevelClassId: this.firstLevelClassId,
        secondLevelClassId: this.secondLevelClassId,
        userId: this.userId,
        source: "本地上传",
        createTime: this.createTime,
        collectionTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        fileUrl: this.fileUrl,
      };
    },
    /**
     * 清楚页面数据
     */
    clearData() {
      this.articleTitle = "";
      this.createTime = "";
      this.inputTag = "";
      this.firstLevelClassId = null;
      this.secondLevelClassId = null;
      this.tags.splice(0, this.tags.length);
      this.add_tags = [];
      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      this.collectionTime = null;
      this.fileList = [];
      this.tags.splice(0, this.tags.length);
    },
    clearFormData() {
      this.articleTitle = "";
      this.inputTag = "";
      this.firstLevelClassId = null;

      this.fileList = [];
      this.tags.forEach((tag) => {
        tag.isselected_up = false;
      });
    },
    /**
     * 保存文章
     */
    save() {
      if (this.fileList.length <= 0) {
        this.$alert("请先上传文章", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.articleTitle) {
        this.$alert("请先上传文章", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.firstLevelClassId || !this.secondLevelClassId) {
        this.$alert("请选择文章分类", "警告", {
          confirmButtonText: "确定",
        });
      } else if (this.tags.length === 0) {
        this.$alert("请添加标签", "警告", {
          confirmButtonText: "确定",
        });
      } else {
        const data = this.getFormData();

        console.log("当前表单数据：", data);
        let that = this;
        SaveUploadArticle({
          articleTitle: data.articleTitle,
          firstSortId: data.firstLevelClassId,
          secondSortId: data.secondLevelClassId,
          tagList: data.tags.filter((tag) => tag.isselected_up),
        }).then((res) => {
          console.log(res);
          that.$message.success("上传文章成功");
          that.clearData();
          that.$store.dispatch("clearData2");
        });
      }
    },
    /**
     * 预览文章
     */
    preview() {
      const selected_tags = this.tags.filter((tag) => {
        return tag.isselected_up;
      });
      if (this.fileList.length <= 0) {
        this.$alert("请先上传文章", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.articleTitle) {
        this.$alert("请先上传文章", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.firstLevelClassId || !this.secondLevelClassId) {
        this.$alert("请选择文章分类", "警告", {
          confirmButtonText: "确定",
        });
      } else if (selected_tags.length === 0) {
        this.$alert("请添加标签", "警告", {
          confirmButtonText: "确定",
        });
      } else {
        this.$store.dispatch("recordData2", this.getFormData());
        console.log(this.getFormData());
        this.$router.push({
          name: "artlocalpre",
          params: {
            refresh: true,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.save_btn {
  background-image: url("../assets/save.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 60px;
}

.preview_btn {
  background-image: url("../assets/yulan.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.btns_con {
  margin-top: 60px;
  width: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inlabel_up {
  margin: 2px;
  background-color: #007ec3;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
  color: #fff6d5;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.el-dropdown-link_right {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  margin-right: 10px;
  font-size: 18px;
}

.el-dropdown-link_left {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  font-size: 18px;
  margin-right: 10px;
}

.type_ses_left_con {
  flex-grow: 2;
  display: flex;
  align-items: center;
}

.add_img {
  width: 21px;
  height: 21px;
}

.type_ses_con {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.add_in::placeholder {
  font-size: 18px;
  color: #999999;
}

.add_in:focus {
  outline: none;
}

.add_in_con1 {
  width: 465px;
}

.add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.txt_label {
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.line_con {
  margin-top: 30px;
  display: flex;
  align-items: center;
}

.artcol_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artcol_top_bar {
  display: flex;
  align-items: center;
}

.delete-tag_up {
  margin-left: 8px;
  /* 与标签文本的间距 */
  color: red;
  /* ×的颜色 */
  cursor: pointer;
  /* 鼠标悬停时的光标形状 */
  font-weight: bold;
  /* 字体加粗 */
}

/* 标签容器样式 */
.label_con_up {
  display: flex;
  /* 使用 Flex 布局 */
  flex-wrap: wrap;
  /* 允许标签换行 */
  max-width: 85%;
  /* 确保容器不超出界面宽度 */
}

/* 单个标签的基本样式 */
.out_label_up {
  display: inline-flex;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 5px 10px;
  background-color: #f0f0f0;
  /* 默认背景色 */
  border: 1px solid #ddd;
  /* 默认边框颜色 */
  border-radius: 4px;
  /* 圆角边框 */
  align-items: center;
  cursor: pointer;
  width: 13%;
}

/* 标签内容样式 */
.label_con_uptent_up {
  display: flex;
  align-items: center;
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏超出容器部分 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  padding: 5px 10px;
  /* 内边距 */
  background-color: #f0f0f0;
  /* 背景颜色 */
  border-radius: 4px;
  /* 圆角边框 */
  width: 100%;
}
.selected_up {
  color: #2f8dc0;
  background-color: #2f8dc0;
  border-right: 3px solid #2f8dc0; /* 深蓝色边框 */
  padding: 5px 10px; /* 增加内边距 */
  border-radius: 5px; /* 圆角 */
  transition:
    background-color 0.3s,
    border-color 0.3s; /* 平滑过渡 */
}

.selected_up:hover {
  background-color: #005e8a; /* 深蓝色背景 */
  border-color: #043148; /* 深蓝色边框 */
}
</style>
